import { defineComponent as _defineComponent } from 'vue'
import type { TextRecommendationFragment } from '@/features/why-to-watch/graphql/fragments/TextRecommendation.fragment';

import PosterGraphql from '@/components/poster/PosterGraphql.vue';

import { useTextRecommendation } from '@/helpers/composables/useTextRecommendation';


export default /*#__PURE__*/_defineComponent({
  __name: 'TextRecommendationPreview',
  props: {
    textRecommendation: null
  },
  setup(__props: any) {

const props = __props as { textRecommendation: TextRecommendationFragment };



const { textRecTitle } = useTextRecommendation({ textRecommendation: () => props.textRecommendation });

return { __sfc: true,props, textRecTitle, PosterGraphql }
}

})